export const styles = {
  codeField: 'w-[12rem]',
  codeMenu: 'min-w-[25rem] w-[25rem]',
  numberField: 'flex-1',
};
